import { ToolOutlined } from "@ant-design/icons";
import { type FunctionComponent } from "react";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconToolOutlined: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return <ToolOutlined {...props} />;
};
